// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"317d1011","95":"e18b5ee8","199":"8ed04e3f","347":"27147a6d","811":"862781c7"}[chunkId] + ".chunk.js";
};